// extracted by mini-css-extract-plugin
module.exports = {"errorMessageSlot":"ErrorMessageSlotLegacy_errorMessageSlot__Cg_6U","addToBag":"ErrorMessageSlotLegacy_addToBag__MAFzy"};